import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

export default function AdminRenewalHistory() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        setLoading(true);
        const q = filter === "all" ? "" : `?owner_type=${filter}`;
        adminFetch(`${API_BASE}/api/get_renewal_history.php${q}`)
            .then((r) => r.json())
            .then((res) => { if (res.success) setRows(res.renewals); })
            .finally(() => setLoading(false));
    }, [filter]);

    const fmt = (n) => `₹ ${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    return (
        <div>
            <h5 className="fw-bold mb-1">Renewal History</h5>
            <p className="text-secondary small mb-3">
                Every renewal/package purchase, kept separately from the general wallet ledger (CR #7) so usage over time is easy
                to see per customer or agent.
            </p>

            <div className="d-flex align-items-center gap-2 mb-3">
                <label className="form-label small mb-0">Filter:</label>
                <select className="form-select form-select-sm w-auto" value={filter} onChange={(e) => setFilter(e.target.value)}>
                    <option value="all">All</option>
                    <option value="customer">Customers</option>
                    <option value="agent">Agents</option>
                </select>
            </div>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : rows.length === 0 ? (
                        <div className="p-3 text-secondary">No renewal history yet.</div>
                    ) : (
                        <table className="table table-sm mb-0">
                            <thead className="table-light">
                                <tr><th>Owner</th><th>Business</th><th>Package</th><th className="text-end">Amount</th><th>When</th></tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.id}>
                                        <td className="small">
                                            {r.owner_type === "customer" ? (r.customer_name || r.owner_uid) : `Agent ${r.owner_uid}`}
                                        </td>
                                        <td className="small">{r.listing_title || "—"}</td>
                                        <td className="small">{r.package_name || "—"}</td>
                                        <td className="text-end fw-semibold">{fmt(r.amount)}</td>
                                        <td className="text-secondary small">{r.created_at}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
